import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { setQuestionResult, setCurrentQuestion, setPrevQuestion, goQuestionBack } from '../../actions'
import OptionsQuestion from './OptionsQuestion'
import MinutesQuestion from './MinutesQuestion'
import TimeQuestion from './TimeQuestion'
import { INTRO_QUESTIONS_SUCCESS } from '../../constants/routes'

class IntroQuestions extends Component {
    constructor(props) {
        super(props)

        this.addAnswer = this.addAnswer.bind(this)
        this.loadPrevQuestion = this.loadPrevQuestion.bind(this)
    }

    addAnswer(option) {
        const { currentQuestionIndex, setResult } = this.props

        setResult(currentQuestionIndex, option.value)
        this.loadNextQuestion(option)
    }

    loadNextQuestion(option) {
        const { setPrev, setCurrent, currentQuestionIndex } = this.props
        const { nextQuestion } = option

        if (nextQuestion !== null) {
            setPrev(currentQuestionIndex)
            setCurrent(nextQuestion)
            window.scrollTo(0, 0)
            return
        }

        this.props.history.push(INTRO_QUESTIONS_SUCCESS)
        setCurrent(0)
    }

    loadPrevQuestion() {
        const { prevQuestionIndex, setCurrent, goBack } = this.props

        if (typeof prevQuestionIndex !== 'undefined') {
            goBack()
            setCurrent(prevQuestionIndex)
            window.scrollTo(0, 0)
        }
    }

    render() {
        const { questions, currentQuestionIndex, prevQuestionIndex } = this.props

        const currentQuestion = questions[currentQuestionIndex]

        switch (currentQuestion.type) {
            case 'minutes':
                return (
                    <div>
                        <MinutesQuestion
                            text={currentQuestion.text}
                            onAnswerClicked={this.addAnswer}
                            onBackClicked={this.loadPrevQuestion}
                            nextQuestion={currentQuestionIndex + 1}
                        />
                    </div>
                )
            case 'time':
                return (
                    <div>
                        <TimeQuestion
                            text={currentQuestion.text}
                            onAnswerClicked={this.addAnswer}
                            onBackClicked={this.loadPrevQuestion}
                            nextQuestion={currentQuestionIndex + 1}
                        />
                    </div>
                )
            case 'option':
            default:
                return (
                    <div>
                        <OptionsQuestion
                            text={currentQuestion.text}
                            options={currentQuestion.options}
                            fullWidth={currentQuestion.optionsFullWidth}
                            onAnswerClicked={this.addAnswer}
                            onBackClicked={this.loadPrevQuestion}
                            isFirst={typeof prevQuestionIndex === 'undefined'}
                        />
                    </div>
                )
        }
    }
}

const mapStateToProps = state => ({
    questions: state.introQuestions.questions,
    currentQuestionIndex: state.currentQuestionIndex,
    prevQuestionIndex: state.prevQuestionIndex.slice(-1)[0],
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        setResult: setQuestionResult,
        setCurrent: setCurrentQuestion,
        setPrev: setPrevQuestion,
        goBack: goQuestionBack,
    }),
)(IntroQuestions)



// WEBPACK FOOTER //
// ./src/components/IntroQuestions/IntroQuestions.js